export const nonPharmacologicalTypes = [
  'nasalSalineRinses',
  'nasalSalineSprays',
  'nasalLubricants'
];

export const nonPharmacologicalCards = [
  {
    type:'nasalSalineRinses',
    header: "Nasal Saline Rinses (Optional)",
    subheader: "Rinses out mucus and allergens/irritants to reduce symptoms.",
    clinicalPoints: () => {
      return (
        <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
          <li className="">
            Rinses should only be used in patients who are able to use the device(s)
          </li>
          <li className="">
            Only distilled or boiled and then cooled water should be used and system
            must be regularly cleaned.
          </li>
          <li className="">
            Reduce the need for pharmacological treatment in children and adults.
          </li>
          <li className="">
            Preferred initial treatment in pregnancy, during breastfeeding, or in
            patients with comorbidities that limit the use of pharmacologic treatment
            options.
          </li>
          <li className="">Adherence may be difficult.</li>
        </ul>
      );
    },
    specialPopulationPoints: () => {
      return (
        <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
          <li className="">
            Preferred initial treatment in pregnancy, during
            breastfeeding/chestfeeding, or in patients with comorbidities that limit
            the use of pharmacologic treatment options.
          </li>
        </ul>
      );
    },
  },
  {
    type:'nasalSalineSprays',
    header: "Nasal Saline Sprays or Drops (Optional)",
    subheader: "Relieves congestion and dryness.",
    clinicalPoints: () => {
      return (

        

        <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
          <li className="">
          Reduce the need for pharmacological treatment in children and adults.
          </li>
          <li className="">
          Preferred initial treatment in pregnancy, during breastfeeding, or in patients with comorbidities that limit the use of pharmacologic treatment options
          </li>
        </ul>
      );
    },
    specialPopulationPoints: () => {
      return (
        
        <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
          <li className="">
          Preferred initial treatment in pregnancy, during breastfeeding/chestfeeding, or in patients with comorbidities that limit the use of pharmacologic treatment options.
          </li>
        </ul>
      );
    },
  },
  {
    type:'nasalLubricants',
    header: "Nasal Lubricants & Gels (Optional)",
    subheader: "Reduce dryness and irritation in the nose.",
    clinicalPoints: () => {
      return (
        <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
          <li className="">
          Common ingredients include:
          <br/> 
          macrogol, polyethylene glycol, propylene glycol or sesame oil.
          </li>
        </ul>
      );
    },
    specialPopulationPoints: () => {
      return (
        <ul className="list-disc px-[20px] flex flex-col gap-2 text-body-sm font-medium text-gray-800">
          <li className="">
          Preferred initial treatment in pregnancy, during breastfeeding/chestfeeding, or in patients with comorbidities that limit the use of pharmacologic treatment options.
          </li>
        </ul>
      );
    },
  },
];
